import type { MeResponse } from '../../entities/me/me-contract.types';
import { isJwtPlatformSuperadminSession } from '../../shared/access/access';

/** Эффективная организация для шапки: имперсонация СА/переключение, иначе `organization_id` из снимка `/auth/me`. */
export function staffTopbarEffectiveOrganizationId(
  me: Pick<MeResponse, 'role' | 'organization_id'> | null | undefined,
  impersonateOrganizationId: number | null | undefined
): number | null {
  if (impersonateOrganizationId != null && impersonateOrganizationId > 0) {
    return impersonateOrganizationId;
  }
  const oid = me?.organization_id;
  if (oid != null && oid > 0) return oid;
  return null;
}

/**
 * Центральный лукап организации скрыт, справа показывается плашка «Контекст организации»:
 * — СА: только при активной имперсонации (как раньше);
 * — не СА: при ненулевом эффективном контексте организации в tenant shell.
 */
export function staffTopbarOrgContextPlaqueReplacesCenterPicker(
  me: Pick<MeResponse, 'role' | 'organization_id'> | null | undefined,
  impersonateOrganizationId: number | null | undefined
): boolean {
  const eff = staffTopbarEffectiveOrganizationId(me, impersonateOrganizationId);
  if (eff == null || eff <= 0) return false;
  if (isJwtPlatformSuperadminSession(me)) {
    return impersonateOrganizationId != null && impersonateOrganizationId > 0;
  }
  return true;
}

/** Кнопка сброса на плашке: только при активном `X-Impersonate-Organization-Id` (СА и переключение орг. у тенанта). */
export function staffTopbarOrgContextPlaqueShowClearAction(
  impersonateOrganizationId: number | null | undefined
): boolean {
  return impersonateOrganizationId != null && impersonateOrganizationId > 0;
}
